export const TicketQueryKeys = {
  all: () => ["tickets"],
  single: (ticketId: string) => [...TicketQueryKeys.all(), ticketId],
  summary: () => [...TicketQueryKeys.all(), "summary"],
  mergePreview: (ticketIds: string[], subject: string) => [
    ...TicketQueryKeys.all(),
    "mergePreview",
    [...ticketIds].sort().join(","),
    subject,
  ],
  insights: () => [...TicketQueryKeys.all(), "insights"],
  insightStatus: () => [...TicketQueryKeys.insights(), "status"],
};
